import { Link } from "react-router-dom";
import { PARKED } from "@/data/core";
import { IllustrativeBadge } from "@/components/IllustrativeBadge";
import { ArrowLeft, ArrowUpRight, Archive } from "lucide-react";

export default function ReferenceHub() {
  return (
    <div className="mx-auto max-w-4xl px-5 py-10 sm:px-8" data-testid="reference-hub">
      <Link to="/" className="mb-6 inline-flex items-center gap-1.5 text-sm font-medium text-mill-muted hover:text-mill-ink" data-testid="back-to-core"><ArrowLeft className="h-4 w-4" /> Back to the core proof</Link>
      <div className="mb-2 flex items-center gap-3"><IllustrativeBadge /></div>
      <h1 className="font-display text-3xl font-bold text-mill-ink">Future journeys & design components</h1>
      <p className="mt-2 flex items-center gap-2 text-mill-muted"><Archive className="h-4 w-4" /> Not part of the core proof — retained as reference material and reusable components.</p>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        {PARKED.map((p) => (
          <Link key={p.to} to={p.to} data-testid={`parked-${p.to.replace(/\W+/g, "-")}`} className="group flex items-center justify-between rounded-2xl border border-stone-200 bg-white p-5 transition-all hover:-translate-y-0.5 hover:shadow-sm">
            <div>
              <p className="font-display font-semibold text-mill-ink">{p.label}</p>
              <p className="text-xs text-mill-muted">{p.note}</p>
            </div>
            <ArrowUpRight className="h-4 w-4 text-mill-muted group-hover:text-mill-moss" />
          </Link>
        ))}
      </div>
    </div>
  );
}
